/**
 * @hidden
 */
export var MIN_DOC_LINK = 'http://www.telerik.com/kendo-angular-ui/components/inputs/api/NumericTextBoxComponent/#toc-min';
/**
 * @hidden
 */
export var MAX_DOC_LINK = 'http://www.telerik.com/kendo-angular-ui/components/inputs/api/NumericTextBoxComponent/#toc-max';
/**
 * @hidden
 */
export var POINT = ".";
/**
 * @hidden
 */
export var INITIAL_SPIN_DELAY = 500;
/**
 * @hidden
 */
export var SPIN_DELAY = 50;



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-inputs/dist/es/numerictextbox/constants.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/numerictextbox/constants.js
// module chunks = 3